import gateways from './gateways';
import general from './general';
import pending from './pending.js';
import { Router } from '@/legacy/Router';

Router.get('payment/gateways', gateways);
Router.get('payment/general', general);
Router.get('payment/([a-zA-Z]+)/pending', pending);
